// eslint-disable-next-line import/prefer-default-export
export const ucFirst = string =>
    `${string.substring(0, 1).toUpperCase()}${string.substring(1)}`;
